import { JoinAndConnectResult } from "@/hooks/livekit/useJoinAndConnect";
import {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
  useState,
  Dispatch,
  SetStateAction,
} from "react";

type LivekitContextType = {
  livekitContext: JoinAndConnectResult | null;
  setLivekitContext: Dispatch<SetStateAction<JoinAndConnectResult | null>>;
};

const LivekitContext = createContext<LivekitContextType | null>(null);

export function LivekitContextProvider({ children }: PropsWithChildren) {
  const [livekitContext, setLivekitContext] =
    useState<JoinAndConnectResult | null>(null);

  const contextValue = useMemo(
    () => ({
      livekitContext,
      setLivekitContext,
    }),
    [livekitContext]
  );

  return (
    <LivekitContext.Provider value={contextValue}>
      {children}
    </LivekitContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export const useLivekitContext = (): LivekitContextType => {
  const ctx = useContext(LivekitContext);
  if (!ctx)
    throw new Error(
      "useLivekitContext must be used inside LivekitContextProvider"
    );
  return ctx;
};
